// angular
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

// others
import { AppService } from '../../../../app.service';
import { AuthService } from '../../../../core/auth.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { DefaultCardComponent } from '../default-card.component';
import { ProfileService } from '../../../profile/profile.service';
import { CoreService } from '../../../../core/core.service';
import { MeDashboardService } from '../../me-dashboard.service';
import { DocumentsService } from '../../../../home/patient/document-dashboard/documents.service';
import { saveAs } from 'file-saver';

@Component({
    selector: 'documents-card',
    templateUrl: './documents-card.component.html',
    styleUrls: ['./documents-card.component.scss'],
    providers: [DocumentsService]
})

export class DocumentsCardComponent extends DefaultCardComponent implements OnInit {
    data: any;
    submitted: boolean;
    checked: boolean = false;
    documents = [];

    @Input() callApi = true;
    @Input() blockData = false;
    @Input() profile: any;
    @Input() slug: string;
    @Input() srStep: number;
    @Input() patientStep: number;
    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public translate: TranslateService,
        public coreService: CoreService,
        public router: Router,
        public profileService: ProfileService,
        public authService: AuthService,
        public meDBService: MeDashboardService,
        public documentService: DocumentsService,
    ) {
        super(appService, fb, translate, coreService, router, profileService, authService);
    }

    @Output() updateUI = new EventEmitter();

    ngOnInit() {
        // this.url = this.url + '/' + this.storyBlock;
        this.meDBService.getDocuments().subscribe(res => {
            this.documents = res['files'] || [];
        });
        if (this.callApi) {
            this.url = this.url + '/' + this.slug;
            this.getContent();
            this.translate.onLangChange.subscribe(value => {
                this.getContent();
            });
        } else {
            this.data = this.blockData['content'];
        }
    }

    submit(value, valid, form) {
        this.editting = false;
        return super.submit(this.form.value, this.form.valid, this.form);
    }

    /**
     * @param params
     */
    openFormModal(params: Object, navigate = false) {
        this.initForm(params, navigate);
        this.editting = true;

    }

    download(document){
        this.documentService.download(document.id)
            .subscribe(data => {
                setTimeout(() => {
                    saveAs(data['body'], document['original_file_name']);
                }, 500);
            });
    }

    getFileType(fileName){
        const ext = fileName.substr(fileName.lastIndexOf('.') + 1);
        return ext;
    }

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }
}
